export const useHeadMissionGoogleForJobs = (mission: Mission) => {
  const { $filters, $dayjs } = useNuxtApp()

  try {
    if (!mission) {
      return
    }

    if (mission.state !== 'Validée') {
      return
    }

    let description = `<h3><strong>Description de la mission :</strong></h3><br><br> ${mission.objectif}`

    if (mission.description) {
      description = `${description} <h3><strong>Précisions :</strong></h3><br><br> ${mission.description}`
    }

    useHead({
      script: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            '@context': 'https://schema.org/',
            '@type': 'JobPosting',
            title: `Bénévolat - ${mission.name}`,
            description: description,
            identifier: {
              '@type': 'PropertyValue',
              name: mission.structure.name,
              value: mission.id,
            },
            datePosted: $dayjs(mission.created_at).format('YYYY-MM-DD'),
            validThrough: mission.end_date ? $dayjs(mission.end_date).format('YYYY-MM-DD') : null,
            applicantLocationRequirements: {
              '@type': 'Country',
              name: 'France',
            },
            jobLocationType: mission.type === 'Mission à distance' ? 'TELECOMMUTE' : null,
            jobLocation:
              mission.type === 'Mission en présentiel'
                ? mission.addresses.map((address: MissionAddress) => ({
                    '@type': 'Place',
                    address: {
                      '@type': 'PostalAddress',
                      streetAddress: address.label,
                      addressLocality: address.city,
                      addressRegion: $filters.label(address.department, 'departments'),
                      postalCode: address.zip,
                      addressCountry: 'FR',
                    },
                  }))
                : null,
            employmentType: 'VOLUNTEER',
            hiringOrganization: {
              '@type': 'Organization',
              name: mission.structure.name,
              sameAs: mission.structure.website,
              logo: mission.structure.logo?.urls?.original,
            },
          }),
        },
      ],
    })
  } catch (e: Error | any) {
    console.log('Error in useHeadMissionGoogleForJobs', e?.message)
    return
  }
}
